import { Dictionary } from "./common_types";

export interface GlobalSubheader {
  pageName: string;
  subheaderTitle: string;
  superScript: string;
  link: string;
  brokerList: Array<BrokerDetail>;
  entitlementList: Array<BrokerDetail>;
  subheaderChanged?: boolean;
  ticker?: string;
  dpParams?: Dictionary<any>;
  isAuditCall: AuditCallBool;
  disableActions: boolean;
  revisionExportDate: string;
}

export interface AuditCallBool {
  expanded: boolean;
}

export interface BrokerDetail {
  id: string;
  name: string;
}

export class FormulaBarData {
  dp: string = "";
  cut: string = "";
  ticker: string = "";
  source: string = "";
  growthType: string = "";
  shouldLog: boolean = true;
  period: string = "";
  pg: string = "";
  extras: string = "";
  currency: string = null;
  historicalRevision?: string = "";
  param?: string = "";
  isdebug: boolean = true;
  is_universalsliid?: boolean = null;
  logic_based_consensus?: boolean = null;
  refdate?: string = "";
  earnings?: number;
  tpr_page?: boolean = null;
  incl_sources?: Array<number> = null;
  excl_sources?: Array<number> = null;
  parent_prefix?: string = null;
  excl_reaffirm_broker_consensus?: boolean = null;
  partial_entitled_sid?: string = null;
  requested_depth_level?: number = 1;
  source_doc_mapping? = null;
  isNav?: boolean = false;

  toDTO() {
    const baseObj = {
      dp: String(this.dp),
      cut: String(this.cut),
      ticker: String(this.ticker),
      source: String(this.source),
      growthType: String(this.growthType),
      shouldLog: Boolean(this.shouldLog),
      period: String(this.period),
      pg: String(this.pg),
      extras: String(this.extras),
      isdebug: Boolean(this.isdebug),
      currency: String(this.currency),
      requested_depth_level: Number(this.requested_depth_level),
      source_doc_mapping: this.source_doc_mapping,
    };
    const optionalObj = {};
    if (this.refdate) {
      optionalObj["refdate"] = String(this.refdate);
    }
    if (this.isNav) {
      optionalObj["isNav"] = Boolean(this.isNav);
    }
    if (this.earnings) {
      optionalObj["earnings"] = Number(this.earnings);
    }
    if (this.logic_based_consensus) {
      optionalObj["logic_based_consensus"] = Boolean(
        this.logic_based_consensus,
      );
    }
    if (this.param) {
      optionalObj["param"] = String(this.param);
    }
    if (this.historicalRevision) {
      optionalObj["historicalRevision"] = String(this.historicalRevision);
    }
    if (this.parent_prefix) {
      optionalObj["parent_prefix"] = String(this.parent_prefix);
    }
    if (this.excl_reaffirm_broker_consensus !== void 0) {
      optionalObj["excl_reaffirm_broker_consensus"] = Boolean(
        this.excl_reaffirm_broker_consensus,
      );
    }
    if (this.partial_entitled_sid) {
      optionalObj["partial_entitled_sid"] = String(this.partial_entitled_sid);
    }
    if (this.is_universalsliid !== void 0) {
      optionalObj["is_universalsliid"] = Boolean(this.is_universalsliid);
    }
    if (this.tpr_page !== void 0) {
      optionalObj["tpr_page"] = Boolean(this.tpr_page);
    }
    if (this.incl_sources && this.incl_sources.length > 0) {
      optionalObj["incl_sources"] = [...this.incl_sources];
    }
    if (this.excl_sources && this.excl_sources.length > 0) {
      optionalObj["excl_sources"] = [...this.excl_sources];
    }

    return {
      ...baseObj,
      ...optionalObj,
    };
  }

  static fromJson(jsonObj) {
    const dpDataObj = new FormulaBarData();
    dpDataObj.dp = jsonObj.dp || "";
    dpDataObj.cut = jsonObj.cut || "";
    dpDataObj.ticker = jsonObj.ticker || "";
    dpDataObj.source = jsonObj.source || "";
    dpDataObj.growthType = jsonObj.growthType || "";
    dpDataObj.currency = jsonObj.currency || "";
    dpDataObj.period = jsonObj.period || "";
    dpDataObj.pg = jsonObj.pg || "";
    dpDataObj.extras = jsonObj.extras || "";
    dpDataObj.isNav = jsonObj.isNav || false;
    dpDataObj.requested_depth_level = jsonObj.requested_depth_level || 1;
    dpDataObj.source_doc_mapping = jsonObj.source_doc_mapping || null;
    if (jsonObj.refdate) {
      dpDataObj["refdate"] = String(jsonObj.refdate);
    }
    if (jsonObj.earnings) {
      dpDataObj["earnings"] = Number(jsonObj.earnings);
    }
    if (jsonObj.logic_based_consensus) {
      dpDataObj["logic_based_consensus"] = Boolean(
        jsonObj.logic_based_consensus,
      );
    }
    if (jsonObj.param) {
      dpDataObj["param"] = jsonObj.param;
    }
    if (jsonObj.historical_revision) {
      dpDataObj["historicalRevision"] = jsonObj.historical_revision;
    }
    if (jsonObj.parent_prefix) {
      dpDataObj["parent_prefix"] = jsonObj.parent_prefix;
    }
    if (jsonObj.excl_reaffirm_broker_consensus !== null) {
      dpDataObj["excl_reaffirm_broker_consensus"] =
        jsonObj.excl_reaffirm_broker_consensus;
    }
    if (jsonObj.partial_entitled_sid) {
      dpDataObj["partial_entitled_sid"] = jsonObj.partial_entitled_sid;
    }
    if (jsonObj.is_universalsliid !== null) {
      dpDataObj["is_universalsliid"] = jsonObj.is_universalsliid;
    }
    if (jsonObj.tpr_page !== null) {
      dpDataObj["tpr_page"] = jsonObj.tpr_page;
    }
    if (jsonObj.incl_sources && jsonObj.incl_sources.length > 0) {
      dpDataObj["incl_sources"] = [...jsonObj.incl_sources];
    }
    if (jsonObj.excl_sources && jsonObj.excl_sources.length > 0) {
      dpDataObj["excl_sources"] = [...jsonObj.excl_sources];
    }
    return dpDataObj;
  }
}
